// extracted by mini-css-extract-plugin
module.exports = {"fantasySection":"style_fantasySection__UsOi5","itemTitle":"style_itemTitle__b_ivW","iframeVideo":"style_iframeVideo__Js_q0","infoDesc":"style_infoDesc__DvG3r"};